import { render, staticRenderFns } from "./MyConfirmButton.vue?vue&type=template&id=b5e9cffe&scoped=true&"
import script from "./MyConfirmButton.vue?vue&type=script&lang=js&"
export * from "./MyConfirmButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5e9cffe",
  null
  
)

export default component.exports